/* eslint-disable getter-return, no-empty */
// Test via a getter in the options object to see if the passive property is accessed
let supportsPassive = false;
try {
    const opts = Object.defineProperty({}, 'passive', {
        get() {
            supportsPassive = true;
        },
    });
    const noop = () => {};
    window.addEventListener('testPassive', noop, opts);
    window.removeEventListener('testPassive', noop, opts);
} catch (e) {}

module.exports = supportsPassive;
